<template>
  <div class="card group-card">
    <header class="card-header">
      <p class="card-header-title">{{ group.name }}</p>
    </header>
    <div class="card-content">
      <div class="content">
        <div class="columns group-info">
          <div class="column is-narrow">
            <p class="is-family-secondary">
              <span class="has-text-weight-bold tw-text-black">
                {{ group.address }}
              </span>
              <span class="tw-px-4">&#8226;</span>
              <span class="tw-text-black">
                {{ group.members_count }} members
              </span>
            </p>
          </div>
          <div class="column">
            <div class="group-members">
              <figure
                v-for="member in members"
                :key="member.id"
                class="image is-32x32"
              >
                <img class="is-elongated" :src="member.avatar_thumb_url" />
              </figure>
            </div>
          </div>
          <div class="column is-narrow" v-if="!group.is_member">
            <b-button type="is-primary" @click.prevent="openMessageForm()"
              >Message Leaders</b-button
            >
          </div>
          <div
            class="column is-narrow"
            v-if="
              currentUserGroup &&
                currentUserGroup.id == group.id &&
                !group.is_owner
            "
          >
            <b-button
              type="is-primary"
              @click="doLeaveGroup(group)"
              :loading="isLeavingGroup"
              outlined
            >
              Leave Group
            </b-button>
          </div>
          <div class="column is-narrow" v-if="!currentUserGroup">
            <b-button
              type="is-primary"
              @click="doJoinGroup(group)"
              :loading="isJoiningGroup"
              outlined
            >
              Join Group
            </b-button>
          </div>
          <div
            v-if="group.is_owner || group.is_group_leader"
            class="column is-narrow"
          >
            <router-link
              class="button is-primary"
              :to="{ name: 'groups.edit' }"
            >
              Edit Group
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <MessageLeadersModal ref="messageLeader"></MessageLeadersModal>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import Group from '@/models/Group'
import MessageLeadersModal from '@/components/modals/MessageLeaders'

export default {
  components: {
    MessageLeadersModal
  },
  computed: {
    ...mapState({
      user: state => state.auth.user
    }),
    ...mapGetters('auth', ['currentUserGroup']),
    members() {
      return this.group.members
    }
  },
  data() {
    return {
      isLeavingGroup: false,
      isJoiningGroup: false,
      messageLeaderModal: false
    }
  },
  props: {
    group: {
      type: Group
    },
    displayMembersCount: {
      type: Number,
      default: 10
    }
  },
  methods: {
    ...mapActions('auth', {
      joinGroup: 'joinGroup',
      leaveGroup: 'leaveGroup'
    }),
    doLeaveGroup(group) {
      this.isLeavingGroup = true
      this.leaveGroup(group)
        .then(() => this.$router.go())
        .finally(() => (this.isLeavingGroup = false))
    },
    doJoinGroup(group) {
      this.isJoiningGroup = true
      this.joinGroup(group)
        .then(() => this.$router.go())
        .finally(() => (this.isJoiningGroup = false))
    },
    openMessageForm() {
      this.$refs.messageLeader.open()
    }
  }
}
</script>
